export default "__VITE_ASSET__e42922cc__"